import React from 'react';
import './RefundPolicy.css';

const RefundPolicy = () => {
  return (
    <div className="policy-page">
      <div className="container">
        <div className="policy-content">
          <h1>Refund Policy</h1>
          <p className="last-updated">Last Updated: {new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}</p>
          
          <section>
            <h2>1. General Policy</h2>
            <p>
              Any Edge (Pvt) Ltd operates the vCard digital business card platform as a subscription-based 
              service. Due to the digital nature of our products and services, <strong>all sales are final 
              and non-refundable</strong>, except as required by applicable law or as explicitly stated 
              in this policy.
            </p>
          </section>

          <section>
            <h2>2. Non-Refundable Services</h2>
            <p>The following are non-refundable:</p>
            <ul>
              <li>All subscription fees (Monthly and Annual plans)</li>
              <li>Premium and Enterprise plan upgrades</li>
              <li>One-time service fees</li>
              <li>Custom domain purchases</li>
              <li>White-label service fees</li>
              <li>Any add-on features or services</li>
            </ul>
            <p>
              Once a payment is processed and your subscription is activated, you will have immediate 
              access to the features associated with your selected plan. As these are digital services 
              that are immediately accessible upon payment, refunds are not available.
            </p>
          </section>

          <section>
            <h2>3. Subscription Cancellation</h2>
            <h3>3.1 Cancellation Rights</h3>
            <p>
              You may cancel your subscription at any time through your account dashboard. Cancellation 
              will take effect at the end of your current billing period. You will continue to have 
              access to all paid features until the end of your billing cycle.
            </p>

            <h3>3.2 No Refund for Partial Periods</h3>
            <p>
              If you cancel your subscription before the end of your billing period, you will not receive 
              a refund for the remaining days. Your subscription will remain active until the end of the 
              paid period, after which it will be downgraded to the Free plan or cancelled.
            </p>
          </section>

          <section>
            <h2>4. Exceptions</h2>
            <h3>4.1 Duplicate Charges</h3>
            <p>
              If you are charged multiple times for the same subscription period due to a technical error 
              on our part, we will refund the duplicate charges. Please contact our support team 
              immediately if this occurs.
            </p>

            <h3>4.2 Service Unavailability</h3>
            <p>
              If our service is unavailable for more than 48 consecutive hours due to our fault, we may, 
              at our discretion, provide a credit or partial refund. This does not apply to scheduled 
              maintenance or circumstances beyond our control.
            </p>

            <h3>4.3 Legal Requirements</h3>
            <p>
              Nothing in this policy affects your statutory rights under applicable consumer protection 
              laws. If you are located in a jurisdiction that provides mandatory refund rights for digital 
              services, those rights will apply.
            </p>
          </section>

          <section>
            <h2>5. Payment Disputes</h2>
            <p>
              If you believe you have been charged incorrectly, please contact our support team within 
              7 days of the charge. We will investigate the matter and, if an error is confirmed, we 
              will correct it promptly.
            </p>
          </section>

          <section>
            <h2>6. Chargebacks</h2>
            <p>
              If you initiate a chargeback or payment dispute with your bank or credit card company, 
              we reserve the right to immediately suspend or terminate your account. We will work with 
              you and your financial institution to resolve the dispute. Please contact us first before 
              initiating a chargeback.
            </p>
          </section>

          <section>
            <h2>7. Free Trial Period</h2>
            <p>
              If we offer a free trial period, you will not be charged until the trial period ends. 
              If you cancel before the trial period ends, no charges will be made. If you do not 
              cancel, your subscription will automatically begin and charges will apply according to 
              your selected plan.
            </p>
          </section>

          <section>
            <h2>8. Plan Downgrades</h2>
            <p>
              If you downgrade your subscription plan, the change will take effect at the end of your 
              current billing period. No refund will be provided for the difference between plans. 
              You will retain access to your current plan's features until the billing period ends.
            </p>
          </section>

          <section>
            <h2>9. Refund Processing</h2>
            <p>
              In the rare event that a refund is approved (as per the exceptions above), refunds will 
              be processed to the original payment method within 5-10 business days. The time it 
              takes for the refund to appear in your account depends on your bank or payment provider.
            </p>
          </section>

          <section>
            <h2>10. Contact for Refund Inquiries</h2>
            <p>
              If you have questions about this Refund Policy or wish to discuss a specific situation, 
              please contact us at:
            </p>
            <p>
              <strong>Any Edge (Pvt) Ltd</strong><br />
              Email: support@vcardapps.com<br />
              Website: www.vcardapps.com
            </p>
            <p>
              Please include your account email and transaction details when contacting us regarding 
              refund inquiries.
            </p>
          </section>

          <section>
            <h2>11. Changes to This Policy</h2>
            <p>
              We reserve the right to modify this Refund Policy at any time. Changes will be effective 
              immediately upon posting on this page. Your continued use of our service after changes 
              are posted constitutes acceptance of the updated policy.
            </p>
          </section>

          <section>
            <h2>12. Acknowledgment</h2>
            <p>
              By making a purchase or subscribing to our service, you acknowledge that you have read, 
              understood, and agree to this Refund Policy. You understand that all sales are final 
              and non-refundable except as explicitly stated in this policy.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default RefundPolicy;
